/**
 * alerabat.com — coupons and cashback (Polish shopping assistant)
 *
 * A single WAR entry exposes the top-level img PNGs and SVGs, content.css, the woff2 fonts
 * and every locale JSON file to every origin with no use_dynamic_url, so each is fetchable
 * from any page at a fixed URL. The vendor-named `img/alelogo.png` is an image, so it loads
 * through probeImage with no CORS grant and survives a strict page CSP.
 *
 * Manifest verified against version 0.43.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'dacdinoicboceafielngnmjjplncljhj';

export const alerabat: ExtensionDefinition = {
  id: ID,
  name: 'alerabat.com | kupony i cashback',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 400_000,
  notes:
    'img/*.png, content.css and locales JSON exposed to every origin with no dynamic ' +
    'URL. The vendor-named alelogo.png is conclusive and CORS-free.',
  signals: [
    {
      id: 'war-alelogo-png',
      kind: 'web-accessible-resource',
      description:
        'Load img/alelogo.png via <img> — the vendor logo exposed to every origin; needs no ' +
        'CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'img/alelogo.png'),
    },
    {
      id: 'war-content-css',
      kind: 'web-accessible-resource',
      description: 'Fetch content.css — the injected content stylesheet, a second path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content.css'),
    },
    {
      id: 'war-locales-en-messages',
      kind: 'web-accessible-resource',
      description:
        'Fetch locales/en/messages.json — a bundled locale file exposed under the ' +
        'locales glob, independent of the image and CSS paths.',
      weight: 0.5,
      run: () => probeFetch(ID, 'locales/en/messages.json'),
    },
  ],
};
